import Deque from 'double-ended-queue';
import cloneDeep from 'lodash/cloneDeep';
import partial from 'lodash/partial';
import values from 'lodash/values';

export const PRIORITY = {
  HIGH: 'HIGH',
  LOW: 'LOW',
};

const priorityOrder = [PRIORITY.HIGH, PRIORITY.LOW];
const STARTING_QUEUE_SIZE = 100;
const STARTING_CONCURANCY = 3;
let concurancy = STARTING_CONCURANCY;
let runningTasks = new Set();
const priorityQueues = {};
values(PRIORITY).map(pKey => (priorityQueues[pKey] = new Deque(100)));

const fetchCache = {};

export function queueFetch(fetch, url, options, priority = PRIORITY.LOW) {
  const clonedOptions = cloneDeep(options);

  const cacheKey = JSON.stringify({
    url: url,
    options: clonedOptions,
  });

  const cached = fetchCache[cacheKey];
  if (cached !== undefined) {
    return cached;
  }

  const task = partial(fetch, url, clonedOptions);
  const taskPromise = queueTask(task, priority);

  fetchCache[cacheKey] = taskPromise;

  return taskPromise;
}

export function queueTask(func, priority = PRIORITY.LOW) {
  let data = { func: func };
  data.promise = new Promise(function(resolve, reject) {
    data.resolve = resolve;
    data.reject = reject;
  });

  priorityQueues[priority].push(data);

  tick();

  return data.promise;
}

function tick() {
  let nextTask;
  for (let pKey of priorityOrder) {
    nextTask = priorityQueues[pKey].dequeue();
    if (nextTask !== undefined) {
      break;
    }

    if (runningTasks.size >= concurancy) {
      return;
    }
  }

  if (nextTask === undefined) {
    return;
  }

  runTask(nextTask);
}

async function runTask(taskData) {
  runningTasks.add(taskData);
  await Promise.resolve(taskData.func())
    .then(taskData.resolve)
    .catch(taskData.reject);
  runningTasks.delete(taskData);
  tick();
}

export async function loadImage(url) {
  return new Promise(function(resolve, reject) {
    const img = new Image();
    img.onload = () => resolve(url);
    img.onerror = () => reject(url);
    img.src = url;
  });
}



// WEBPACK FOOTER //
// ./src/lib/tasks.js